import { render, staticRenderFns } from "./shareManage.vue?vue&type=template&id=6faca8e2&scoped=true&"
import script from "./shareManage.vue?vue&type=script&lang=js&"
export * from "./shareManage.vue?vue&type=script&lang=js&"
import style0 from "./shareManage.vue?vue&type=style&index=0&id=6faca8e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faca8e2",
  null
  
)

export default component.exports